var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.3 1.142a.875.875 0 0 1 .7-.35h10c.275 0 .535.13.7.35l2.5 3.333a.875.875 0 0 1 .175.525v11.667a2.542 2.542 0 0 1-2.542 2.541H4.167a2.542 2.542 0 0 1-2.542-2.541V5c0-.19.061-.373.175-.525l2.5-3.333Zm1.138 1.4L4.25 4.125h11.5l-1.188-1.583H5.438Zm11.187 3.333H3.375v10.792a.792.792 0 0 0 .792.791h11.666a.791.791 0 0 0 .792-.791V5.875ZM6.667 7.458c.483 0 .875.392.875.875a2.458 2.458 0 1 0 4.916 0 .875.875 0 0 1 1.75 0 4.208 4.208 0 1 1-8.416 0c0-.483.391-.875.875-.875Z",
    clipRule: "evenodd"
  })));
};
export default SvgShoppingBag;